module.exports = __webpack_public_path__ + "static/media/test11_2.a0058a35.png";